import React, {createContext, useContext, useEffect, useRef, useState} from 'react';
import logo from "../../_asset/image/ROYALCASINO.png";
import api, {ApiErrorHandler} from "../../util/api";
import {UserContext} from "../_root";
import {gameType, vendorSum} from "../../component/provider/lobby_modal_provider";
import {with_comma} from "../../util/comma";

import {Player} from "@lottiefiles/react-lottie-player";
import ready_casino from "../../_asset/lottie/loading.json"
import loading from "../../_asset/lottie/loading.json"
import blackjack from "../../_asset/lottie/blackjack.json"

import {compL_casino, otherCasino} from "../../data/gameData_casino";
import {compL_slot} from "../../data/gameData_slot";
import {SiteLogo, SiteLogo2} from "../../component/common/header";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faWon} from "@fortawesome/free-solid-svg-icons";

import swal from "sweetalert"

interface vendorSetInterface {
    LobbyVendor: string,
    setLobbyVendor: (argVendor: string)=> void,
}
const ContextVendor = createContext<vendorSetInterface>({
    LobbyVendor: "",
    setLobbyVendor: (argVendor: string)=> {},
})
export default function Lobby({vendor, type, handleClose}: {vendor: vendorSum, type: gameType, handleClose: Function}) {
    const [LobbyVendor, SetVendor] = useState<string>(vendor.vendor)

    function setLobbyVendor(argVendor: string){
        SetVendor(argVendor)
    }
    useEffect(()=> {
        SetVendor(LobbyVendor)
    }, [LobbyVendor])

    return (
        <ContextVendor.Provider value={{ LobbyVendor, setLobbyVendor }}>
            {
                type == 'slot' || otherCasino.includes(vendor.vendor)
                    ? <LocalLobby vendor={vendor} type={type} handleClose={handleClose}/>
                    : <IframeLobby vendor={vendor} handleClose={handleClose} />
            }
        </ContextVendor.Provider>
    )
}

interface openLink {
    link: string
}
function IframeLobby({vendor, handleClose}: {vendor: vendorSum, handleClose: Function}){
    const [iframeLink, setIframeLink] = useState<string>()
    const [loadingState, setLoadingState] = useState<boolean>(true)
    const {UserAuth} = useContext(UserContext)

    let responseAPIUrl = `/api/game/lobbies/link/honor?vendor=${vendor.vendor}&id=${vendor.id}`
    if(vendor.vendor == 'evolution I') {
        responseAPIUrl = `/api/game/lobbies/link/oracle?vendor=${vendor.vendor}&id=${vendor.id}`
    }

    function getHonorLink(){
        api(responseAPIUrl)
            .then(res => res.json())
            .then((data: openLink) => {
                // console.log(data.link)
                // if(data?.link){
                //     window.open(data.link, `lobby`,`popup,width=1200, height=600`)
                // }
                if(data?.link){
                    setIframeLink(data.link)
                }
            })
            .catch((res: Response)=> {
                ApiErrorHandler(res, ()=> {
                    handleClose()
                })
            })
    }
    function iframeOnLoad(){
        setLoadingState(false)
    }
    useEffect(()=> {
        getHonorLink()
    }, [])
    return (
        <main className={'iframe-modal-main'}>
            {
                loadingState
                    ? <div className={'iframe-loading-animation'}>
                        <Player src={blackjack} loop autoplay/>
                    </div>
                    : <></>
            }
            {
                iframeLink
                    ? UserAuth
                        ? <iframe className={'lobby-honor-link-iframe'}
                                  onLoad={iframeOnLoad}
                                  src={iframeLink}
                                  frameBorder={0}></iframe>
                        : <p className={'logout-failed'}>로그아웃 되었습니다.</p>
                    : <div className={'iframe-loading-empty'}
                           onLoad={iframeOnLoad}></div>
            }
        </main>
    )
}

function LocalLobby({vendor, type, handleClose}: {vendor: vendorSum, type: gameType, handleClose: Function}){
    const [gameList, setGameList] = useState<vendorGameListInterface[]>()
    const [listShow, setListShow] = useState<boolean>(false)

    const { User } = useContext(UserContext)
    const {LobbyVendor} = useContext(ContextVendor)

    let compL;
    if(type == 'casino'){
        compL = compL_casino
    }else{
        compL = compL_slot
    }


    useEffect(()=> {
        let apiUrl: string;
        switch(LobbyVendor){
            case "PragmaticPlay J" :
                apiUrl = `/api/game/games/pragmatic/`;
                break;
            default:
                apiUrl = `/api/game/games/honor/?vendor=${LobbyVendor}`;
                break;
        }
        api(apiUrl)
            .then((res)=> res.json())
            .then((data: vendorGameListInterface[]) => {
                setTimeout(()=> {
                    setGameList(data)
                }, 1000)
            })
            .catch((res: Response)=> {
                swal({
                    text: "현재 이용 불가능 한 게임사 입니다.",
                    icon: "error",
                }).then(function(){
                    handleClose()
                })
            })
    }, [])
    useEffect(()=> {
        if(gameList){
            setListShow(true)
        }else{
            setListShow(false)
        }
    }, [gameList])

    function Ready(){
        return (
            <div className={'ready'}>
                <Player src={ready_casino}
                        autoplay={true}
                        loop={true}
                        style={{width: '30rem', height: '30rem'}}
                ></Player>
                {/*<p>준비중 입니다.</p>*/}
            </div>
        )
    }
    return (
        <div className={'local-lobby'} rel={'root'}>
            <header className={'lobby-header'}>
                <SiteLogo2/>

                <div className={'user-money'}>
                    {
                        ` ${with_comma(User ? User.money : Number(sessionStorage.getItem('money')))}`
                    } <FontAwesomeIcon icon={faWon}/>
                </div>
            </header>
            <div className={'select-company'}>
                <div className={'company'}>
                    {
                        //@ts-ignore
                        <img src={compL[LobbyVendor].logo} title={LobbyVendor}/>
                    }
                </div>
                {/*<div className={'company'}>{vendor}</div>*/}
            </div>
            {
                gameList
                    ? <LobbyLayout gameList={gameList} LobbyVendor={LobbyVendor} type={type}/>
                    : <Ready/>
            }
        </div>
    )
}
interface vendorGameListInterface {
    uid: string,
    title: string,
    vendor: string,
    thumbnail: string
}
export function LobbyLayout({gameList, LobbyVendor, type}: {gameList: vendorGameListInterface[], LobbyVendor: string; type: gameType}){

    function Loading(){
        return (
            <div className={'loading'}>
                <Player src={loading}
                        autoplay={true}
                        style={{ width: "30rem", height: "30rem" }}
                        loop={true}></Player>
            </div>
        )
    }
    return (
        <main className={'lobby-main'}>
            {
                gameList
                    ? <div className={'company-list'}>
                        {
                            gameList?.map((list, index)=> {
                                if(list.thumbnail){
                                    return (
                                        <CompanyItems key={index} list={list} vendor={LobbyVendor}/>
                                    )
                                }
                            })
                        }
                    </div>
                    : <Loading/>
            }
        </main>
    )
}

function CompanyItems({list, vendor}: {list: vendorGameListInterface, vendor: string}){
    const [imgLoadState, setImageLoadState] = useState<boolean>(true)


    if(imgLoadState){
        return (
            <div className={'company-items'}
                 onClick={e=> {
                     window.open(`/gameLobby/${vendor}/?uid=${list.uid}&vendor=${list.vendor}`,
                         `${list.vendor}_${list.uid}`, `width=1200 height=640`)
                     // let openUrl = `https://circus001.com/api/game/games/link/honor?uid=${list.uid}&vendor=${list.vendor}`
                     // if(vendor == 'PragmaticPlay J'){
                     //     openUrl = `https://circus001.com/api/game/games/link/pragmatic?uid=${list.uid}`
                     // }
                     // window.open(openUrl,
                     //     `${list.vendor}_${list.uid}`, `width=1200 height=840`)
                 }}
            >
                <div className={'game-image'}>
                    <img src={list.thumbnail} onError={e=>setImageLoadState(false)}/>
                </div>
                <div className={'game-name'}>
                    {list.title}
                </div>
            </div>
        )
    }else{
        return <></>
    }
}

